


// initiate payment start

import { apiToken, phonepeInitiatePaymentUrl, razorPayInitiatePaymentUrl, razorPayPaymentStatusUrl } from "../config";

/**
 * Initiates a payment using the PhonePe API.
 * @param {Object} data - The payment data to be sent in the request body.
 * @returns {Promise<Object>} - The response from the API.
 */
export const phonepeInitiatePayment = async (data) => {
    try {
        const response = await fetch(phonepeInitiatePaymentUrl
            , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const res = await response.json();
        return res;
    } catch(e) {
        console.error("Error initiating payment:", e);
        throw e; // Re-throw the error for further handling
    }
}

// initiate payment end

// razor pay payment start
export const razorPayInitiatePayment = async (data) => {
    try{
        const response = await fetch(razorPayInitiatePaymentUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const res = await response.json();
        return res;
    } catch(e) {
        console.error("Error initiating RazorPay payment:", e);
        throw e; // Re-throw the error for further handling
    }
}

// razor pay payment end

// razorpay payment status
export const razorPayPaymentStatus = async (paymentId) => {
    try {
        const response = await fetch(`${razorPayPaymentStatusUrl}${paymentId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        if(!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const res = await response.json();
        return res;
    } catch(e) {
        console.error("Error fetching RazorPay payment status:", e);
        throw e; // Re-throw the error for further handling
    }
}

// razorpay status end